import React, { useState } from "react";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { Box } from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import ValidationController from "../../../../components/common/inputFields/ValidationController";
import { FormDataContainer } from "../../cabinets/files/addFile/styled";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";
import ProfileUpload from "../../../../components/common/uploadFiles/profileUpload";
import {
  PlaceholderImg,
  TrashIcon,
  TrashRedIcon,
} from "../../../../components/styled/AllImages";

const TempUserPersonalInfo = ({
  register,
  control,
  errors,
  userSections,
  setUserSections,
  watch,
  resetField,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [profileImg, setProfileImg] = useState(null);
  const handleDeleteUser = (sectIndexToRemove) => {
    resetField(`users[${sectIndexToRemove}].name`);
    resetField(`users[${sectIndexToRemove}].email`);
    resetField(`users[${sectIndexToRemove}].phone`);
    resetField(`users[${sectIndexToRemove}].profile`);

    setUserSections((prev) =>
      prev.filter((sectIndex) => sectIndex !== sectIndexToRemove)
    );
  };

  return (
    <FormDataContainer className="user-personal-info">
      {userSections?.map((sectIndex) => (
        <React.Fragment key={sectIndex}>
          <Box className="profileWrapper position-relative">
            <Box className="profileAvatarContainer">
              <Box className="profileAvatarImg">
                <ValidationController
                  name={`users[${sectIndex}].profile`}
                  validationConfig={{
                    required: false,
                  }}
                  errors={errors}
                  control={control}
                  renderer={({ field }) => (
                    <ProfileUpload
                      UploadImage="UploadLogo"
                      initialImage={field?.value}
                      onFileSelect={(file) => {
                        field.onChange(file);
                        setProfileImg(file);
                      }}
                    />
                  )}
                />
              </Box>
            </Box>
            {sectIndex > 0 && (
              <Box
                className="position-absolute delete-btn"
                onClick={() => handleDeleteUser(sectIndex)}
              >
                <TrashRedIcon />
              </Box>
            )}
          </Box>

          <ValidatedInput
            name={`users[${sectIndex}].name`}
            type={"input"}
            fieldType={"text"}
            label="name"
            placeholder={t("namePlaceholder")}
            staric={true}
            errors={errors}
            register={register}
            validationRules={{ required: true }}
            sectIndex={sectIndex}
          />

          <ValidatedInput
            name={`users[${sectIndex}].email`}
            type={"input"}
            fieldType={"email"}
            placeholder={t("emailPlaceholder")}
            label={t("email")}
            staric={true}
            register={register}
            errors={errors}
            validationRules={{ required: true }}
            sectIndex={sectIndex}
          />

          <PhoneInputField
            name={`users[${sectIndex}].phone`}
            label={"contact_no"}
            staric={true}
            placeholder={"phonePlaceholder"}
            register={register}
            control={control}
            errors={errors}
            validationRules={{
              required: true,
            }}
            sectIndex={sectIndex}
          />
        </React.Fragment>
      ))}
    </FormDataContainer>
  );
};

export default TempUserPersonalInfo;
